// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navMenu{margin-right:-43px}.badgeCustom{width:100%;border-radius:7px;background-color:#f26149;color:#fff;text-align:center;font-size:8px;margin-right:5px;padding:1px 1px 1px 3px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
